<template>
  <div class="dashboard-section">
    <div>
      <h5>Please Choose a Building</h5>
    </div>
    <b-container fluid>
      <div
        v-if="loading"
        class="loading"
        style="text-align: center; margin-top: 100px"
      >
        <b-spinner variant="danger" />
      </div>
      <div v-if="!loading" class="row mt-2 mb-2">
        <b-button
          v-for="(item, i) in buildingLists"
          :key="i"
          size="lg"
          variant="outline-success"
          style="margin: 10px"
          @click="handleClick(item.qdo_url, item.building_name)"
        >
          {{ item.building_name }}
        </b-button>
      </div>
    </b-container>
  </div>
</template>
<script>
//
export default {
  data() {
    return {
      buildingLists: [],
      loading: true,
    };
  },

  mounted() {
    this.getBuildings();
  },
  methods: {
    getBuildings() {
      let outletCodes = JSON.parse(
        localStorage.getItem('pos-order-outlet') || '{}'
      );
      // console.log(outletCodes.value);
      if (outletCodes.value) {
        this.$store
          .dispatch('GetBuildings', outletCodes.value)
          .then((res) => {
            this.loading = false;
            // console.log(res);
            for (const tb of res.data) {
              this.buildingLists.push(tb);
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      }
    },
    handleClick(url, building_name) {
      const type = this.$route.query.type;
      sessionStorage.setItem('building_name', building_name);
      if (type === 'post_pay') {
        this.$router.push('/pos-order?type=room');
      } else {
        window.location.href = url + '&source=QBIZ';
      }
    },
  },
};
</script>
